import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export interface IdleLogoutWarningDialogProps {
  open: boolean;
  /** Milliseconds remaining until automatic logout. */
  remainingMs: number;
  onContinue: () => void;
}

/**
 * "Är du kvar?" dialog shown 60s before an idle logout (GRA-80). No cancel /
 * outside-click dismissal — the only way out is to confirm you're still
 * there, otherwise the idle timer (and thus the logout) just keeps running.
 */
export function IdleLogoutWarningDialog({
  open,
  remainingMs,
  onContinue,
}: IdleLogoutWarningDialogProps) {
  const { t } = useTranslation("common");
  const seconds = Math.max(0, Math.ceil(remainingMs / 1000));

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("idleLogout.warningTitle")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("idleLogout.warningDescription", { seconds })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogAction onClick={onContinue}>
          {t("idleLogout.continueButton")}
        </AlertDialogAction>
      </AlertDialogContent>
    </AlertDialog>
  );
}
